module.exports = __webpack_public_path__ + "static/img/autCt_bg_white_06.e2197e9e.svg";